/* eslint-disable camelcase */
module.exports = function (self) {
	return {
		async tags({ order_by = 'users', offset = 0, limit = self.limit, type = 'group,category,brand,store,hashtag' }) {
			try {
				const response = await self.$http.get(
					'admin/stats/tags', {
						params: {
							order_by,
							offset,
							limit,
							type,
						},
						headers: {
							Authorization: true,
						},
					},
				);

				return {
					ok: true,
					data: response.data.stats,
					error: null,
				};
			} catch (error) {
				return {
					ok: false,
					data: [],
					error: null,
				};
			}
		},
		async users() {
			try {
				const response = await self.$http.get(
					'admin/stats/totalUsers', {
						headers: {
							Authorization: true,
						},
					},
				);

				return {
					ok: true,
					data: response.data.stats.users,
					error: null,
				};
			} catch (error) {
				return {
					ok: false,
					data: [],
					error: null,
				};
			}
		},
		async registers({ offset = 0, limit = self.limit }) {
			try {
				const response = await self.$http.get(
					'admin/stats/registersPerDay', {
						params: {
							offset,
							limit,
						},
						headers: {
							Authorization: true,
						},
					},
				);

				return {
					ok: true,
					data: response.data.stats,
					error: null,
				};
			} catch (error) {
				return {
					ok: false,
					data: [],
					error: null,
				};
			}
		},
	};
};
